define('collections/metrik_users',['require','collections/base','models/metrik_user'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/metrik_user");

    return BaseCollection.extend({
        model: Model,
        url: 'metrik-users.json'
    });
});

